/* eslint-disable react/no-danger */
import React from 'react';
import { motion } from 'framer-motion';
import { isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BoxedContainer from '../layouts/BoxedContainer';
import Icons from '../layouts/Icons';
import Button from '../layouts/Button';

export default function AcademiesDetailsIntro({ data }) {
  const {
    title,
    textContent,
    academyContactName,
    websiteLink,
    logo,
    academyContactPhone,
    academyContactEmail,
    facebook,
    instagram,
    linkedin,
    tiktok,
    twitter,
    youtube,
  } = data;

  const socialLinks = { facebook, instagram, linkedin, tiktok, twitter, youtube };

  return (
    <section
      className="lg:pt-[180px] pt-[90px] lg:pb-[118px] pb-[90px] bg-white lg:-mt-[80px]
    -mt-[20px]"
    >
      <BoxedContainer className="regular">
        <div
          className="flex md:flex-row flex-col lg:gap-x-[90px] gap-x-[60px] md:gap-y-0
          gap-y-[30px] justify-between"
        >
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.4 }}
            viewport={{ once: true }}
            className="flex flex-col lg:gap-y-[46px] md:gap-y-[25px] gap-y-[15px] 2xl:w-[65%]
            md:w-[80%]"
          >
            {isEmpty(title) || (
              <h2
                className="xl:text-2xl lg:text-[40px] md:text-[30px] text-[25px] lg:leading-[60px]
                md:leading-[50px] leading-[1.5]  text-primary uppercase font-roboto-condensed-bold"
              >
                {title}
              </h2>
            )}
            <div
              className="lg:text-base text-[15px] leading-7 text-primary flex flex-col gap-y-4
              font-roboto-regular"
              dangerouslySetInnerHTML={{ __html: textContent }}
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.6 }}
            viewport={{ once: true }}
            className="flex flex-col lg:gap-y-[52px] md:gap-y-[38px] gap-y-[20px] md:w-[34%]"
          >
            <div
              className="h-[80px] lg:h-[100px] xl:h-[120px] 2xl:h-[140px] 3xl:h-[160px]
              4xl:h-[180px]"
            >
              {isEmpty(logo) || (
                <LazyLoadImage
                  src={logo.url}
                  alt={title}
                  className="w-auto h-full object-contain"
                />
              )}
            </div>
            <div className="flex flex-col lg:gap-y-[38px] gap-y-[20px]">
              <div className="flex flex-col gap-y-[2px]">
                <h4 className="text-base font-roboto-bold text-primary">Contact Details</h4>
                {isEmpty(academyContactName) || (
                  <p className="text-primary font-roboto-regular text-base">{academyContactName}</p>
                )}
                {isEmpty(academyContactPhone) || (
                  <a
                    href={`tel:${academyContactPhone}`}
                    className="text-primary font-roboto-regular text-base hover:underline
                    transition-all"
                  >
                    {academyContactPhone}
                  </a>
                )}
                {isEmpty(academyContactEmail) || (
                  <a
                    href={`mailto:${academyContactEmail}`}
                    className="text-primary font-roboto-regular text-base hover:underline
                    transition-all"
                  >
                    {academyContactEmail}
                  </a>
                )}
              </div>
              <div className="flex flex-row gap-x-[18px]">
                {Object.keys(socialLinks).map(
                  (key) =>
                    socialLinks[key] && (
                      <a
                        key={key}
                        href={socialLinks[key]}
                        rel="noreferrer"
                        target="_blank"
                        className="social-media-button"
                        aria-label="social-media-button"
                      >
                        <Icons icon={key} className="w-[24px] h-[24px] text-black" />
                      </a>
                    ),
                )}
              </div>
            </div>
            {isEmpty(websiteLink) || (
              <Button
                label={websiteLink.name}
                url={websiteLink.url}
                target={websiteLink.target}
                ariaLabel={websiteLink.name}
                variant="primaryRed"
                text="w-[170px]"
                tagName="visit-website"
              />
            )}
          </motion.div>
        </div>
      </BoxedContainer>
    </section>
  );
}
